import { render } from "./productBundle.vue?vue&type=template&id=7e2b6ba0"
import script from "./productBundle.vue?vue&type=script&lang=js"
export * from "./productBundle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__